import { render, staticRenderFns } from "./activeLuckyCorrectLists.vue?vue&type=template&id=9e0e388c&"
import script from "./activeLuckyCorrectLists.vue?vue&type=script&lang=js&"
export * from "./activeLuckyCorrectLists.vue?vue&type=script&lang=js&"
import style0 from "./activeLuckyCorrectLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports